import { RegistrationRequest, UploadData } from '../../../../store/uploadStore';

/**
 * Get count of queued files and files that are being registered (and not yet added to the queue)
 */
export const getQueuedAndRegisteringFileCount = (
  upload: UploadData | undefined,
  registrationRequests: Map<Promise<unknown>, RegistrationRequest> | undefined,
) => {
  let count = upload?.queue?.length ?? 0;

  registrationRequests?.forEach((request) => {
    count += request.fileHashes?.length ?? 0;
  });

  return count;
};
